import { toLngLat } from "./coordinates";

const toEntries = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (value && typeof value === "object") return Object.values(value).filter(Boolean);
  return [];
};

export const normalizeHaltmapResponse = (haltmap = {}) => {
  const payload =
    haltmap.data || haltmap.lanes || haltmap.items || haltmap.results || haltmap;

  if (Array.isArray(payload)) {
    return payload.map((lane, index) => ({
      label: lane.key || lane.label || lane.name || `Lane ${index + 1}`,
      lane,
    }));
  }

  if (!payload || typeof payload !== "object") return [];

  return Object.keys(payload)
    .filter((key) => payload[key] && typeof payload[key] === "object")
    .map((key) => ({
      label: payload[key].key || payload[key].label || key,
      lane: payload[key],
    }));
};

export const normalizeLaneSelection = (lane = {}) => {
  const marker =
    lane.value ?? lane.values ?? lane.data ?? lane.halts ?? lane.trips ?? [];

  const source = lane.src ?? lane.source ?? [];
  const destination = lane.dest ?? lane.destination ?? [];

  return {
    marker: toEntries(marker),
    source,
    destination,
  };
};

export const getEntryCoordinates = (entry = {}) => {
  const raw =
    entry.halt_loc ??
    entry.haltLoc ??
    entry.halt_location ??
    entry.haltLocation ??
    entry.location ??
    entry.loc ??
    entry.coordinates;

  const coords = [];
  const locationItems = [];

  const addCoord = (value) => {
    const lngLat = toLngLat(value);
    if (lngLat) coords.push(lngLat);
  };

  if (raw) {
    if (
      Array.isArray(raw) &&
      raw.length >= 2 &&
      typeof raw[0] !== "object"
    ) {
      addCoord(raw);
      return coords;
    }

    if (Array.isArray(raw)) {
      raw.forEach((item) => {
        if (Array.isArray(item)) {
          locationItems.push(item);
          return;
        }

        if (item && typeof item === "object") {
          locationItems.push(item);
          return;
        }

        locationItems.push(item);
      });
    } else {
      locationItems.push(raw);
    }

    locationItems.forEach(addCoord);
    if (coords.length) return coords;
  }

  const lat =
    entry.lat ?? entry.latitude ?? entry.Lat ?? entry.Latitude ?? null;
  const lng =
    entry.lng ??
    entry.longitude ??
    entry.lon ??
    entry.Lng ??
    entry.Longitude ??
    null;

  if (lat != null && lng != null) {
    addCoord([lat, lng]);
  }

  return coords;
};
